import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as UserGroupActions from '../_actions/userGroup';
import { UserGroup } from '../_models/userGroup';

export interface UserGroupState extends EntityState<UserGroup> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<UserGroup> = createEntityAdapter<UserGroup>();

const initialState: UserGroupState = adapter.getInitialState({
  loading: false,
  error: null,
});

const userGroupReducer = createReducer(
  initialState,

  on(UserGroupActions.loadUserGroups, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(UserGroupActions.loadUserGroupsSuccess, (state, { userGroups }) =>
    adapter.setAll(userGroups, { ...state, loading: false })
  ),

  on(UserGroupActions.loadUserGroupsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(UserGroupActions.addUserGroupSuccess, (state, { userGroup }) =>
    adapter.addOne(userGroup, state)
  ),

  on(UserGroupActions.updateUserGroupSuccess, (state, { userGroup }) =>
    adapter.upsertOne(userGroup, state)
  ),

  on(UserGroupActions.deleteUserGroupSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    UserGroupActions.addUserGroupFailure,
    UserGroupActions.updateUserGroupFailure,
    UserGroupActions.deleteUserGroupFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: UserGroupState | undefined, action: Action) {
  return userGroupReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
